// src/pages/productTypes/EditProductTypes.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditProductTypes from "../../components/productTypes/FormAddEditProductTypes";
import useGetProductType from "../../hooks/productTypes/useGetProductType";

const EditProductTypes = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const { isLoading, productType } = useGetProductType(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "400px",
                    }}
                >
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditProductTypes
                isEdit={true}
                currentData={productType}
                onSubmitSuccess={() => navigate("/product-types")}
            />
        </WrapperSection>
    );
};

export default EditProductTypes;